import { render, staticRenderFns } from "./MUploadimg.vue?vue&type=template&id=b49c76e8&"
import script from "./MUploadimg.ts?vue&type=script&lang=ts&"
export * from "./MUploadimg.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports